import React from "react";
import { Input } from "reactstrap";

export default function InputComponent({ item, onDataChange, index, dKey }) {
  const handleOnChange = e => {
    onDataChange(index, e.target.value, dKey);
  };
  console.log(item);
  return (
    <div style={{ flexGrow: 1 }}>
      <Input onChange={handleOnChange} value={item[dKey]} />
    </div>
  );
}
